<template>
	<module-tab name="退货地址" enable-flex @mounted="update" @activated="$refs.table.update()">
		<m-operate>
			<c-button color="main" @click="editHandle()">新建退货地址</c-button>
		</m-operate>
		
		<c-table ref="table" height="grow">
			<c-table-column
				label="收件人"
				name="after_sale_name"
				width="130"
			></c-table-column>
			
			<c-table-column
				label="联系电话/手机"
				name="after_sale_mobile"
				width="180"
			></c-table-column>
			
			<c-table-column
				label="售后地址"
				name="after_sale_address"
				width="400"
			></c-table-column>
			
			<c-table-column
				label="是否启用"
				width="120"
			>
				<template #default="{data}">
					<c-switch v-model="data.state" :state-value="[2, 1]" :state-text="['启用', '禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
				</template>
			</c-table-column>
			
			<c-table-column
				label="创建时间"
				name="create_date"
				width="140"
			>
			</c-table-column>
			
			<c-table-column
				type="button"
				label="操作"
				width="120"
			>
				<template #default="{data}">
					<c-table-button @click="editHandle(data)">编辑</c-table-button>
					<c-table-button @click="delHandle(data)">删除</c-table-button>
				</template>
			</c-table-column>
		</c-table>
		
		<c-dialog ref="dialog" :title="editState ? '编辑售后地址' : '新增售后地址'" width="600" @resolve="addHandle">
			<c-form ref="form">
				<c-input type="hidden" name="id"></c-input>
				<c-form-item label="收件人" required>
					<c-input name="after_sale_name"></c-input>
				</c-form-item>
				<c-form-item label="联系电话/手机" required>
					<c-input name="after_sale_mobile"></c-input>
				</c-form-item>
				<c-form-item label="售后地址" required>
					<c-input name="after_sale_address"></c-input>
				</c-form-item>
				<c-form-item label="是否启用" required>
					<c-radio-group name="state">
						<c-radio value="2">启用</c-radio>
						<c-radio value="1">禁用</c-radio>
					</c-radio-group>
				</c-form-item>
			</c-form>
		</c-dialog>
	</module-tab>
</template>

<script>
	export default {
		data() {
			return {
				editState: false
			}
		},
		
		methods: {
			update() {
				this.$refs.table.load({
					url: '/after_sale_address/list'
				});
			},
			
			stateHandle(state, next, data) {
				this.request({
					url: '/after_sale_address/edit',
					data: {
						id: data.id,
						state: state ? 1 : 2
					},
					success: () => {
						next();
					}
				})
			},
			
			editHandle(data) {
				this.editState = !!data;
				this.$refs.form.clear();
				this.$refs.form.set(data || {
					state: 2
				});
				this.$refs.dialog.open();
			},
			
			delHandle(data) {
				this.$confirm({
					message: '确定要删除【' + data.after_sale_address + '】吗？',
					resolve: () => {
						this.request({
							url: '/after_sale_address/remove',
							data: {
								id: data.id,
							},
							loading: true,
							success: data => {
								this.$message({
									type: 'success',
									message: '删除成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},
			
			addHandle(stop, next) {
				stop();
				this.$refs.form.submit({
					url: this.editState ? '/after_sale_address/edit' : '/after_sale_address/add',
					rule: {
						after_sale_name: '请填写收件人',
						after_sale_mobile: '请填写联系电话/手机',
						after_sale_address: '请填写售后地址'
					},
					success:() => {
						next();
						this.$message({
							type: 'success',
							message: '操作成功'
						});
						this.$refs.table.update();
					}
				});
			}
		}
	}
</script>

<style>
</style>